import { useDroppable } from "@dnd-kit/react";
import styled from "styled-components";
import { TasksEmptyKanbanCard } from "./TasksKanbanCard";

export const TasksKanbanColumn = ({id, title, counter, color, children}) => {

    const { ref } = useDroppable({id});
    const hasValidChildren = Array.isArray(children) && children.some(child => child !== null);

    return (
        <StyledTasksKanbanColumn ref={ref} $color={color}>
            <div className="kanbanColumnHeader">
                <div className="columnTitle">
                    {title}
                </div>
                <div className="columnCounter">
                    {counter}
                </div>
            </div>
            {
                hasValidChildren ? children : <TasksEmptyKanbanCard/>
            }
        </StyledTasksKanbanColumn>
    )
}

const StyledTasksKanbanColumn = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.md};
    border: 1px solid ${({theme}) => theme.colors.neutralPrimaryBorder};
    background: ${({theme}) => theme.colors.neutralSecondaryBackground};
    padding: ${({theme}) => theme.spacing.md} ${({theme}) => theme.spacing.lg};
    border-radius: ${({theme}) => theme.cornerRadius.lg};

    div.kanbanColumnHeader
    {
        display: flex;
        justify-content: space-between;
        align-items: center;

        div.columnTitle
        {
            position: relative;
            padding-left: calc(${({theme}) => theme.spacing.md} + ${({theme}) => theme.spacing.sm} + 8px);
            font-weight: 500;
            &::before
            {
                top: 50%;
                left: ${({theme}) => theme.spacing.sm};
                transform: translateY(-50%);
                position: absolute;
                content: "";
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background: ${({theme, $color}) => $color ? $color : theme.colors.neutralSecondaryForeground};
            }
        }

        div.columnCounter
        {
            padding: ${({theme}) => theme.spacing.xs} ${({theme}) => theme.spacing.sm};
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            background: ${({theme}) => theme.colors.neutralPrimaryBackground};
            color: ${({theme}) => theme.colors.mutedForeground};
            font-size: ${({theme}) => theme.fontSize.sm};
        }
    }
`